import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';

const INITIAL_SHOW_DELAY = 5000;      // ms (5sec) — wait before showing popup on page load
const REAPPEAR_AFTER_DISMISS = 180000; // ms (3 min) — reappear after user closes it
const ROTATE_INTERVAL = 15000;         // ms — swap to next offer automatically while visible
const TRANSITION_PAUSE = 400;          // ms — brief hide while swapping offer

interface Offer {
  title: string;
  description: string;
  image: string;
  page_link: string;
}

// ── Static offer data — edit this JSON block directly ───────────
const OFFERS_DATA: Offer[] = [
  {
    title: 'Expert Webinars 11+ & GCSE Mastery',
    description: 'CSSE  |  FSCE  |  GL  |  SET  |  ISEB  |  AQA  |  OCR  |  EDEXCEL  |  EDUQAS  |  A LEVEL ',
    image: 'assets/images/freewebsinar.jpg',
    page_link: 'https://forms.zohopublic.in/sehyogacademy1/form/SICREGISTRATIONFORM/formperma/7-u7x8iPBrfIWZzrnDaE2OlbJQtRt1KqNKM-RYn3ucQ'
  },
  {
    title: 'With 11+ Summer Intensive Course',
    description: 'This course will be held during the summer holidays Sat 19 Jul to Sun 7 Sep and is intended to give students a final boost before the exams in September.',
    image: 'assets/images/free-mock.webp',
    page_link: 'https://forms.zohopublic.in/sehyogacademy1/form/SICREGISTRATIONFORM/formperma/7-u7x8iPBrfIWZzrnDaE2OlbJQtRt1KqNKM-RYn3ucQ'
  },

  {
    title: '11+ Summer Bootcamp Course',
    description: 'This course will be held during the summer holidays Sat 19 Jul to Sun 7 Sep and is intended to give students a final boost before the exams in September.',
    image: 'assets/images/bootcamp-flyer.png',
    page_link: 'https://forms.zohopublic.in/sehyogacademy1/form/REGISTRATIONFORM4/formperma/hT1C_7ApXrmyfgd75SugwXFK-nRtLgzqjbk2TnmHOTM'
  },

  {
    title: '11+ Summer Intensive Course',
    description: 'This course will be held during the summer holidays Sat 19 Jul to Sun 7 Sep and is intended to give students a final boost before the exams in September.',
    image: 'https://images.unsplash.com/photo-1689326561417-78ad743ff4e2?q=80&w=1041&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    page_link: 'https://forms.zohopublic.in/sehyogacademy1/form/SICREGISTRATIONFORM/formperma/7-u7x8iPBrfIWZzrnDaE2OlbJQtRt1KqNKM-RYn3ucQ'
  }
];

@Component({
  selector: 'app-offer-banner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './offer-banner.component.html',
  styleUrls: ['./offer-banner.component.css']
})
export class OfferBannerComponent implements OnInit, OnDestroy {
  offer: Offer | null = null;
  visible = false;

  private currentIndex = 0;
  private showTimer: any = null;
  private reappearTimer: any = null;
  private rotateTimer: any = null;

  ngOnInit() {
    if (OFFERS_DATA.length) {
      this.currentIndex = 0;
      this.offer = OFFERS_DATA[this.currentIndex];

      this.showTimer = setTimeout(() => {
        this.visible = true;
        this.scheduleRotate();
      }, INITIAL_SHOW_DELAY);
    }
  }

  // ── Auto-rotate between offers while visible ────────────────────
  private scheduleRotate() {
    this.clearRotateTimer();
    if (OFFERS_DATA.length <= 1) { return; }
    this.rotateTimer = setTimeout(() => { this.rotateOffer(); }, ROTATE_INTERVAL);
  }

  private rotateOffer() {
    this.visible = false;
    setTimeout(() => {
      this.currentIndex = (this.currentIndex + 1) % OFFERS_DATA.length;
      this.offer = OFFERS_DATA[this.currentIndex];
      this.visible = true;
      this.scheduleRotate();
    }, TRANSITION_PAUSE);
  }

  // ── User dismisses — reappears after 3 minutes with next offer ──
  dismiss() {
    this.clearRotateTimer();
    this.visible = false;
    this.reappearTimer = setTimeout(() => {
      if (OFFERS_DATA.length > 1) {
        this.currentIndex = (this.currentIndex + 1) % OFFERS_DATA.length;
        this.offer = OFFERS_DATA[this.currentIndex];
      }
      this.visible = true;
      this.scheduleRotate();
    }, REAPPEAR_AFTER_DISMISS);
  }

  // ── Click → navigate ─────────────────────────────────────────
  onBannerClick() {
    if (!this.offer) { return; }
    const link = this.offer.page_link;
    if (!link) { return; }
    if (link.indexOf('/') === 0) {
      window.location.href = link;
    } else {
      window.open(link, '_blank');
    }
  }

  imageSrc(): string {
    if (this.offer && this.offer.image) { return this.offer.image; }
    return 'assets/images/default-offer.png';
  }

  private clearRotateTimer() {
    if (this.rotateTimer) { clearTimeout(this.rotateTimer); this.rotateTimer = null; }
  }

  ngOnDestroy() {
    if (this.showTimer) { clearTimeout(this.showTimer); }
    if (this.reappearTimer) { clearTimeout(this.reappearTimer); }
    this.clearRotateTimer();
  }
}